import Typography from '@mui/material/Typography'

export default function LabelText({ children, ...props }) {
    return (
        <Typography {...props} variant='h6'>{children}</Typography>
    )
}
